import {Component, forwardRef, Input, HostBinding, Output, EventEmitter, HostListener} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';


export class RpCheckboxControlComponent implements ControlValueAccessor {
   label: string;

    checked = false;

   disabled = false;

   check = new EventEmitter();

  touched = false;

  onChange = (x?: any) => {};

  onTouched = () => {};

   onClick() {
    const isChecked = !this.checked;
    this.onChange(isChecked);
    this.checked = isChecked;
    this.touched = true;
    this.onTouched();
    this.check.emit(isChecked);
  }

  writeValue(value) {
    this.checked = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'rp-checkbox-control',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RpCheckboxControlComponent),
    multi: true,
  }],
  template: `
    <rp-control
      [label]="label"
      [touched]="touched"
      [disabled]="disabled"
      [inline]="true"
      (labelClick)="onClick()"
      types="checkbox"
    >
      <input
        #rpControlInput
        [checked]="checked"
        [disabled]="disabled"
        type="checkbox"
      >
    </rp-control>
  `,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
'checked': [{ type: Input },{ type: HostBinding, args: ['class.is-checked', ] },],
'disabled': [{ type: Input },],
'check': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
